export class SelectTag<T> {
  constructor(public label: string, public tag: T) {}
}

export class TestSelectTagModel {
  constructor(public text: string, public uid?: string) {}
}
